import { ScheduleSegment } from "./ScheduleSegment.model";

export class ScheduleEntry {
  id: number;
  type: string;
  name: string;
  order: number;
  subtype: string;
  start_time: Date;
  end_time: Date;
  metadata: any;
  segments: ScheduleSegment[];
  children: ScheduleEntry[];
  parent_id: number;
  /** Ads scheduled on this entry — empty for every type but AD (MPN-1506). */
  ad_ids: number[];

  constructor() {
    this.id = -1;
    this.order = -1;
    this.start_time = new Date();
    this.end_time = new Date();
    this.type = "";
    this.name = "";
    this.metadata = {};
    this.segments = []
    this.children = []
    this.subtype = ""
    this.parent_id = -1
    this.ad_ids = []
  }
}
